/* eslint-disable import/prefer-default-export */
import { schema } from 'normalizr';
import { CourseProfileQuestion } from '../models/account-fields';

export const CourseProfileQuestionSchema = new schema.Entity<CourseProfileQuestion>(
  'courseProfileQuestions',
);
